module.exports = __webpack_public_path__ + "img/icon_TPKC.7c5ddf59.jpg";